export const styles = theme => ({
  POI: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '70vw'
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  map: {
    position: 'relative',
    height: '91vh',
    textAlign: 'left'
  },
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.paper,
    border: '0px solid #000',
    boxShadow: theme.shadows[0],
    outline: 'none'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  title: {
    fontWeight: 'bold',
    alignItems: 'flex-start'
  },
  audioPlayer: {
    display: 'flex',
    marginTop: '3.5px',
    background: '#ce9568',
    alignItems: 'center'
  },
  caption: {
    display: 'flex',
    justifyContent: 'center',
    margin: '.5rem'
  },
  media: {
    minWidth: '100%',
    height: '70vh',
    display: 'flex',
    flexDirection: 'column',
    alignitems: 'center'
  }
});
